var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.phone_see)?_c('Login_phone'):_vm._e(),(_vm.sms)?_c('Login_sms'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }